// @flow

import 'isomorphic-fetch'
import { checkHttpStatus, getApiHeaders, getBaseUrl } from '../utils'
import { getUsers } from './users'
import { getErrorAction } from '../utils/actions'
import { basicGet, checkForPolicyChanges } from '../utils/api'
import { shouldFetchPolicies } from '../utils/policies'
import { userIsLoggedInDataFetched } from './user'
import { fetchDataAndRedirectUser } from './combined'
import type { Action } from '../types/actions/policies'
import type { APIError } from '../types'

export const SET_POLICIES_TO_ACCEPT = 'SET_POLICIES_TO_ACCEPT'
export const UNSET_POLICIES_TO_ACCEPT = 'UNSET_POLICIES_TO_ACCEPT'
export const REQUEST_POLICIES = 'REQUEST_POLICIES'
export const RECEIVE_POLICIES = 'RECEIVE_POLICIES'
export const SHOW_ACCEPT_POLICIES_MODAL_REQUEST =
  'SHOW_ACCEPT_POLICIES_MODAL_REQUEST'
export const HIDE_ACCEPT_POLICIES_MODAL_REQUEST =
  'HIDE_ACCEPT_POLICIES_MODAL_REQUEST'
export const USER_IS_CONSIDERING_DECLINING_POLICIES =
  'USER_IS_CONSIDERING_DECLINING_POLICIES'
export const USER_IS_NOT_CONSIDERING_DECLINING_POLICIES =
  'USER_IS_NOT_CONSIDERING_DECLINING_POLICIES'
export const FAILED_POLICIES = 'FAILED_POLICIES'
export const SET_ACCEPTED_POLICIES_TO_USER = 'SET_ACCEPTED_POLICIES_TO_USER'

export function requestPolicies(): Action {
  return {
    type: REQUEST_POLICIES
  }
}

export function receivePolicies(json: Object): Action {
  return {
    type: RECEIVE_POLICIES,
    policies: json.policies,
    receivedAt: Date.now()
  }
}

export function failedPolicies(error: APIError): Action {
  return getErrorAction(FAILED_POLICIES, error)
}

export function showAcceptPoliciesModal(): Action {
  return {
    type: SHOW_ACCEPT_POLICIES_MODAL_REQUEST,
    showAcceptPoliciesModal: true
  }
}

export function hideAcceptPoliciesModal(): Action {
  return {
    type: HIDE_ACCEPT_POLICIES_MODAL_REQUEST,
    showAcceptPoliciesModal: false
  }
}

export function userIsConsideringDecliningPolicies(): Action {
  return {
    type: USER_IS_CONSIDERING_DECLINING_POLICIES,
    userIsConsideringDecliningPolicies: true
  }
}

export function userIsNotConsideringDecliningPolicies(): Action {
  return {
    type: USER_IS_NOT_CONSIDERING_DECLINING_POLICIES,
    userIsConsideringDecliningPolicies: false
  }
}

export function setPoliciesToAcceptAction(policies: any): Action {
  return {
    type: SET_POLICIES_TO_ACCEPT,
    policiesToAccept: policies
  }
}

export function unsetPoliciesToAcceptAction(): Action {
  return {
    type: UNSET_POLICIES_TO_ACCEPT
  }
}

export function setPoliciesToAccept(policies: any): Function {
  return dispatch => {
    dispatch(setPoliciesToAcceptAction(policies))
    dispatch(showAcceptPoliciesModal())
  }
}

export function setAcceptedPoliciesToUser(policies) {
  return {
    type: SET_ACCEPTED_POLICIES_TO_USER,
    payload: {
      policies: policies
    }
  }
}

export function acceptPolicies(): Function {
  return async (dispatch, getState) => {
    const state = getState()
    try {
      checkHttpStatus(
        await fetch(
          `${getBaseUrl()}/policies/${state.policies.policiesToAccept}/accept`,
          {
            method: 'PATCH',
            headers: getApiHeaders(state)
          }
        )
      )

      await dispatch(setAcceptedPoliciesToUser(state.policies.policiesToAccept))
      dispatch(unsetPoliciesToAcceptAction())
      dispatch(hideAcceptPoliciesModal())

      const newState = await getState()
      dispatch(fetchDataAndRedirectUser(newState.user.user))
      // TODO: I don't love this but org users aren't fetched otherwise
      dispatch(getUsers())
      dispatch(userIsLoggedInDataFetched())
    } catch (error) {
      window.alert('There was an error accepting the policies.')
    }
  }
}

export function fetchPolicies(): Function {
  return (dispatch, getState) => {
    const state = getState()
    const url = `${getBaseUrl()}/policies.json`
    return basicGet(
      state,
      dispatch,
      url,
      requestPolicies,
      receivePolicies,
      failedPolicies
    )
  }
}

export function fetchPoliciesIfNeeded(): Function {
  return (dispatch, getState) => {
    if (shouldFetchPolicies(getState())) {
      return dispatch(fetchPolicies())
    } else {
      // lame af, but without this, this function returns without a promise
      return dispatch(function () {
        return Promise.resolve()
      })
    }
  }
}

export async function userNeedsToAcceptPolicies(token): Function {
  const response = await fetch(`${getBaseUrl()}/quest_maker/api/status`, {
    method: 'GET',
    headers: {
      Authorization: `Token token="${token}"`,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })

  return checkForPolicyChanges(response)
}



// WEBPACK FOOTER //
// ./src/actions/policies.js